import { useContext } from "react";
import "./targetcard.css";
import { ProfileContext } from "../../../context/ProfileContext";

export default function TargetCard() {
  const { user } = useContext(ProfileContext);

  const target = user?.performance?.targetLeads || 0;
  const total = user?.performance?.totalLeads || 0;

  const percent =
    target > 0 ? Math.min(Math.round((total / target) * 100), 100) : 0;

  const remaining = Math.max(target - total, 0);

  return (
    <div className="rp-targetcard-container">
      <div className="rp-targetcard-header">
        <h4>Monthly Target</h4>
        <span className="rp-targetcard-sub">Leads Goal</span>
      </div>

      <div
        className="rp-targetcard-progress-ring"
        style={{
          background: `conic-gradient(#16a085 ${
            percent * 3.6
          }deg, #e6e6e6 0deg)`,
        }}
      >
        <div className="rp-targetcard-progress-inner">
          <h2>{percent}%</h2>
          <p>Completed</p>
        </div>
      </div>

      <div className="rp-targetcard-info">
        <p>
          <strong>{total}</strong> of <strong>{target}</strong> leads
        </p>
        <span>{remaining} more to achieve 🎯</span>
      </div>
    </div>
  );
}
